import type { UpdaterState } from "../hooks/use-electron-updater.js";

declare const __APP_VERSION__: string;

const FALLBACK_VERSION = "0.0.0";

export function resolveCurrentVersion(
  electronState: UpdaterState | null,
): string {
  if (electronState?.currentVersion) return electronState.currentVersion;
  if (typeof __APP_VERSION__ === "string" && __APP_VERSION__.length > 0) {
    return __APP_VERSION__;
  }
  return FALLBACK_VERSION;
}
